import React, { useState, useEffect } from 'react';
import { Admin } from './admin';
import { Editor } from './editor';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../App';
import { Login } from './login';

const btn = {
  padding: '5px',
  margin: '10px',
};
const err = {
  color: 'red',
};

export const Home = () => {

  const navigate = useNavigate();
  const auth = sessionStorage.getItem('ID');
  useEffect(() => {
    if (!auth) {
      navigate('/login');
    }
  }, [auth, navigate]);

  useEffect(() => {
    document.title = '信頼性業務依頼システム';
  }, []);

  const handleLogout = () => {
    sessionStorage.clear();
    navigate('/login');
  }

  return (
    <>
      <div style={{ marginTop: "80px" }}>
        <img src='logo192.png' height={50} width={50} style={{float:'left'}}/>
        <h1>信頼性業務依頼システム</h1>
        <h4>お知らせ</h4>
        <p>・（'25/02/28）コピー新規作成機能を追加、下書き保存機能を修正。</p>
        <br/>
        <p></p>
        <h4>連絡先</h4>
        <p>システムに関する<br/>ご意見・要望、問題などありましたら下記メールまでご連絡ください。</p>
        <a href="mailto:CMbxZ220tkyk-cloud@mail.advics.co.jp?subject=【連絡】信頼性業務依頼システム">CMbxZ220tkyk-cloud@mail.advics.co.jp</a>
      </div>
      <div>

        <div>
          {sessionStorage.getItem("auth") === "admin" && <Admin />}
          {sessionStorage.getItem("auth") === "editor" && <Editor />}
        </div>
      </div>

      <br/>
      <h4>システムについて</h4>
      <p>本システムはサーバレスアーキテクチャにて構成しているため、ロード時間が長くなることがあります。
        <br/>ご迷惑をお掛けしますが、ご了承ください。</p>
      <p>※自社開発システムのため、改善のための仕様変更を高頻度で行う場合があります。</p>
    </>
  );
};
